// src/routes/logistRoutes.js
import AuthRoute from '../modules/Base/Auth/components/AuthRoute';
import Home from '../modules/Logist/index.jsx';
import Analytics from '../modules/Logist/Analytics/Analytics.jsx';
import Drivers from '../modules/Logist/DriverStats/DriverStatsPage';
import Tracking from '../modules/Logist/Tracking/TrackingPage';
import Routes from '../modules/Logist/Routes/LogistRoutes.jsx';
import LogistMain from '../modules/Logist/LogisistMainPage/LogistMain.js';
import LogistMobile from '../modules/Logist/LogistMobilePage/LogistMobile.js';
import Undelivered from '../modules/Dispatcher/Undelivered/Undelivered.js';
import NewLogistPage from '../modules/Logist/NewLogistPage/index.jsx';

const logistRoutes = [
  {path: '/logist',              element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><Home /></AuthRoute>),},
  {path: '/logist/analytics',    element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><Analytics /></AuthRoute>),},
  {path: '/logist/tracking',     element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><Tracking /></AuthRoute>),},
  {path: '/logist/drivers',      element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><Drivers /></AuthRoute>),},
  {path: '/logist/routes',       element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><Routes /></AuthRoute>),},
  {path: '/logist/main',         element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><LogistMain /></AuthRoute>),},
  {path: '/logist/mob',          element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><LogistMobile /></AuthRoute>),},
  {path: '/logist/undelivered',  element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><Undelivered /></AuthRoute>),},
  {path: '/logist/newlogistpage',element: (<AuthRoute requiredPermissions={['pages:logist:view:any']}><NewLogistPage /></AuthRoute>),},
];

export default logistRoutes;
